import React, { useEffect, useState } from "react";
import {Checkbox,Select,Col, Form,Input,Modal,Row,Switch,theme,Spin } from "antd";
import { Typography } from "antd";
import { GET, PATCH, POST } from "../../frameworks/HttpClient";
import { URL_SETTING, URL_TRUCK } from "../../constants/urls";
import ErrorMessages from "../../common/ErrorMessages";
import _ from "lodash";
import TSTable from "../../common/TSTable";
import ColorButton from "../../common/ColorButton";
import { currencyFormat, dateToHumanString } from "../../frameworks/Util";
import dayjs from "dayjs";
import { DATE_FORMAT } from "../../constants/string";
import useDropdownItem from "../../common/useDropdownItem";
import CustomDatePicker from "../../common/CustomDatePicker";

export default function PurchasePaymentVoucherModal(props) {
  const { open, onClose, target, onUpdate } = props;
  const [errorMessages, setErrorMessages] = React.useState(null);
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = React.useState([]);
  const [loading, setLoading] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const tableRef = React.useRef();
  const { Text } = Typography;
  const isCreated = _.get(target, 'id', null) ? false : true;
  const billDate = Form.useWatch('bill_date', form);

  const {
    token: { colorWarning, colorSuccess },
  } = theme.useToken();

  const [company, setCompany] = useState('');

  const companyDropdown = useDropdownItem({
    manual: true,
    url: URL_SETTING.BANK_ACCOUNT,
    label_renderer : (data) => data.bank_name ? `${data.bank_name} - ${data.account_no}` : `${data.account_no}`,
    value: "id",
    pagination: true,
    params: { page_size: 999, account_name: company },
  });

  const debounceCompany = React.useCallback(
    _.debounce((_searchVal) => {
      setCompany(_searchVal);
    }, 800),
    []
  );

  const columns = [
    {
      title: "วันที่",
      key: "created",
      dataIndex: "created",
      render: (value) => dateToHumanString(value),
    },
    {
      title: "รหัสผู้ขาย",
      key: "supplier_code",
      dataIndex: "supplier_code",
      searcher: true,
    },
    {
      title: "ชื่อผู้ขาย",
      key: "supplier_name",
      dataIndex: "supplier_name",
      searcher: true,
    },
    {
      title: "ทะเบียนรถ",
      key: "vehicle_license_plate",
      dataIndex: "vehicle_license_plate",
      searcher: true,
    },
    {
      title: "น้ำหนัก",
      key: "net_weight",
      dataIndex: "net_weight",
      render: (value) => <center>{currencyFormat(value ? value : 0)}</center>
    },
    {
      title: "%DRC",
      key: "drc",
      dataIndex: "drc",
    },
    {
      title: "น้ำหนักยางแห้ง",
      key: "dry_weight",
      dataIndex: "dry_weight",
      render: (value) => <center>{currencyFormat(value ? value : 0)}</center>
    },
    {
      title: "ราคา",
      key: "unit_price",
      dataIndex: "unit_price",
      render: (value) => <center>{currencyFormat(value ? value : 0)}</center>
    },
    {
      title: "จำนวนเงิน",
      key: "net_product_price",
      dataIndex: "net_product_price",
      render: (value) => <center>{currencyFormat(value ? value : 0)}</center>
    },
    {
      title: "ค่าบรรทุก",
      key: "total_wage",
      dataIndex: "total_wage",
      render: (value) => <center>{currencyFormat(value ? value : 0)}</center>
    },
    {
      title: "จำนวนเงินรวม",
      key: "net_price",
      dataIndex: "net_price",
      render: (value) => <center>{currencyFormat(value ? value : 0)}</center>
    },
  ];

  const handleOK = async () => {
    setLoading(true);
    setErrorMessages(null);
    try {
      const data = await form.validateFields();
      if (selectedRowKeys.length > 0) {
        data.truck_transactions = selectedRowKeys;
      } else {
        setErrorMessages(["กรุณาเลือกข้อมูลจากตาราง"]);
        return;
      }
      if (data.bill_date) {
        data.bill_date = dayjs(data.bill_date).format(DATE_FORMAT);
      }
      if (!data.bank_account) {
        data.bank_account = null;
      }
      if (target?.id) {
        await PATCH(`${URL_TRUCK.PAYMENT_TRANSACTION}${target.id}/`, data);
      } else {
        await POST(URL_TRUCK.PAYMENT_TRANSACTION, data);
      }
      onUpdate();
    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setLoading(false);
    }
  };

  const autoGenerateDocumentNo = async () => {
    try {
      const repsonse = await GET(URL_TRUCK.PAYMENT_TRANSACTION_GENERATE_DOCUMENT_NO, { date : billDate});
      const documentNo = _.get(repsonse, 'data.document_no', '')
      if (documentNo) {
        form.setFieldValue('document_no', documentNo);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const rowSelection = {
    selectedRowKeys,
    onSelect: (record, selected) => {
      if(selected === true){
        const newValue = [...selectedRowKeys, record.id]
        setSelectedRowKeys(newValue);
      } else {
        const removedSelectedRowKeys = selectedRowKeys.filter((word) => word != record.id);
        setSelectedRowKeys(removedSelectedRowKeys);
      }
    },
    getCheckboxProps: (record) => ({
      disabled: !isActive ? target ? true : false : false ,
    }),
  };

  const refreshData = async(params) => {
    if(tableRef.current)(
      await tableRef.current.fetchWithoutResetPage(params)
    )
  }

  useEffect(() => {
    if(open)
      companyDropdown.fetchOptions();
  }, [open]);

  useEffect(() => {
    if (target) {
      form.setFieldsValue(target);
      // companyDropdown.addOption({account_name : target.bank_account_detail, id: target.bank_account, value :target.bank_account});
      setSelectedRowKeys(target.truck_transactions)
      setIsActive(false);
    } else {
      form.resetFields();
      setSelectedRowKeys([])
      setIsActive(false);
    }
  }, [open, target]);

  React.useEffect(() => {
    if(open){
      setErrorMessages(null)
      if(target){
        refreshData({payment_availables : target.id, ordering : 'has_payment,-created_date,supplier_code,created'});
      } else {
        refreshData({payment_availables : 'all', ordering : '-created_date,supplier_code,created'});
      }
    }
  },[target, open])

  React.useEffect(() => {
    console.log(selectedRowKeys)
  },[selectedRowKeys])

  React.useEffect(() => {
    if(billDate && isCreated){
      autoGenerateDocumentNo();
    }
  },[billDate])

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title="ใบสำคัญจ่าย"
      width={1100}
      footer={[
        <ColorButton key="close" style={{ marginTop: 10 }} onClick={onClose}>
          ปิด
        </ColorButton>,

        target && isActive && (
          <ColorButton
            key="edit"
            style={{
              marginTop: 10,
              backgroundColor: colorWarning,
              borderColor: colorWarning,
              color: "#ffffff",
            }}
            onClick={handleOK}
            loading={loading}
          >
            แก้ไข
          </ColorButton>
        ),
        !target && (
          <ColorButton
            key="add"
            style={{
              marginTop: 10,
              backgroundColor: colorSuccess,
              borderColor: colorSuccess,
              color: "#ffffff",
            }}
            onClick={handleOK}
            loading={loading}
          >
            เพิ่ม
          </ColorButton>
        ),
      ]}
    >
      <ErrorMessages message={errorMessages} />
      <Form form={form} layout={"vertical"}>
        <Row gutter={(16, 16)}>
          <Col span={24} style={{ marginBottom : 16}}>
            {target ? (
              <Text style={{ marginRight : 10}}>แก้ไขข้อมูลใบสำคัญจ่าย :</Text>
            ) : (
              <Text style={{ marginRight : 10}}>ข้อมูลใบสำคัญจ่าย</Text>
            )}
            {target && (
              <Switch
                checked={isActive}
                onChange={(checked) => setIsActive(checked)}
              />
            )}
          </Col>

          <Col span={7}>
            <Form.Item
              name="document_no"
              label="หมายเลขเอกสาร"
              rules={[{ required: true, message: "กรุณากรอกหมายเลขเอกสาร!" }]}
            >
              <Input
                placeholder="หมายเลขเอกสาร"
                style={{ width: "100%" }}
                disabled={target && !isActive}
              />
            </Form.Item>
          </Col>
          <Col span={7}>
            <CustomDatePicker
              name="bill_date"
              label="วันที่ตัดบัญชี"
              rules={[
                { required: true, message: "กรุณาเลือกวันที่ตัดบัญชี!" },
              ]}
              placeholder="เลือกวันที่ตัดบัญชี"
              disabled={target && !isActive}
              format={DATE_FORMAT}
            />
          </Col>

          <Col span={7}>
            <Form.Item 
              label="บัญชีบริษัท" 
              name="bank_account"
              rules={[
                { required: true, message: "กรุณาเลือกบัญชีบริษัท!" },
              ]}
            >
              <Select
                initialvalues={"-"}
                autoComplete="off"
                placeholder="เลือกบัญชีบริษัท"
                showSearch
                filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                onSearch={debounceCompany}
                notFoundContent={companyDropdown.loading ? <Spin size="small" /> : "-"}
                options={companyDropdown.options}
                allowClear={"-"}
                disabled={target && !isActive}
              />
            </Form.Item>
          </Col>
          <Col span={3}>
            <Form.Item
              name="vat"
              label="ภาษี"
              valuePropName="checked"
              rules={[{ required: false, message: "กรุณาเลือกสถานะภาษี!" }]}
            >
              <Checkbox
                style={{ width: "100%" }}
                disabled={target && !isActive}
              >
                มีภาษี
              </Checkbox>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Spin spinning={loading}>
        {open && <TSTable
          ref={tableRef}
          columns={columns}
          rowSelection={rowSelection}
          loading={loading}
          rowKey={"id"}
          url={URL_TRUCK.TRUCK_TRANSACTION}
          params={{ payment_availables : target ? target.id : 'all', ordering : 'has_payment,-created_date,supplier_code,created'}}
        />}
      </Spin>
    </Modal>
  );
}
